import { AfterViewInit, Component, computed, effect, inject, Input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/app/core/services/language.service';
import { LoaderService } from 'src/app/core/services/shared/loader.service';
import { UrlAuthRedirectService } from 'src/app/shared/pages/url-auth-redirect/url-auth-redirect.service';
import { environment } from 'src/environments/environment';
import { PortalRenderService } from './portal-render.service';
import { CommonModule } from '@angular/common';
import { SanitizerUrlModule } from '@cnet/ngx-ui';
import { AppIframeTrackerModule } from 'src/app/shared/directives/app-iframe-tracker/app-iframe-tracker.module';
import { StartupService } from 'src/app/core/services/startup.service';
import { SharedModule } from 'src/app/shared/shared.module';
@Component({
  selector: 'app-portal-render',
  templateUrl: './portal-render.component.html',
  styleUrls: ['./portal-render.component.scss'],
  imports: [CommonModule, SanitizerUrlModule, AppIframeTrackerModule, SharedModule]
})

export class PortalRenderComponent implements OnInit, AfterViewInit, OnDestroy {

  private readonly startupService = inject(StartupService);
  private readonly loaderService = inject(LoaderService);
  private readonly activeRoute = inject(ActivatedRoute);
  private readonly languageService = inject(LanguageService);
  private readonly _urlAuthRedirectService = inject(UrlAuthRedirectService);
  private readonly portalRenderService = inject(PortalRenderService);


  @ViewChild('iframe') iframe: any;

  heightHeader = environment.env !== 'prd' ? 90 : 60
  heightFooter = '6vh - '

  public _path: string;
  @Input() credential: string;

  @Input()
  get path(): string { return this._path; }

  set path(value: string) {
    if (value) {
      const index = value.indexOf('#') == -1 ? value.length - 1 : value.indexOf('#');
      const char = value.substring(0, index).includes('?') ? '&' : '?';
      const token = this.activeRoute.snapshot.paramMap.get('token');
      const protocol = `${value.includes('http') ? '' : `${environment.httpSchema}://`}`;

      if (value.includes('#')) {
        if (this.credential) {
          this._path = protocol + value.replace('#', `${char}credential=${this.credential}#`);
        }
        else {
          this._path = `${protocol}${value}`;
        }

      } else {
        if (token) {
          this._path = `${protocol}${value}${char}${this.credential ? `credential=${this.credential}` : ''}&token=${token}`;
        } else {
          this._path = `${protocol}${value}${char}${this.credential ? `credential=${this.credential}` : ''}`;
        }
      }

      this.loaderService.show();
      setTimeout(() => {
        this.setIframeSrc(this._path);
      }, 100);

    }
  }

  src = signal('');
  isPDF = computed(() => { return this.src().includes('.pdf') || this.src().includes('/documento/') })

  isIOS = this.startupService.isIOS;

  languageObservable$;

  ngOnInit(): void {
    this.heightHeader = this.activeRoute.snapshot.data.hideHeader ? 0 : environment.env !== 'prd' ? 90 : 60;
    this.heightFooter = this.activeRoute.snapshot.data.hideFooter ? '' : '6vh - ';
    this.languageObservable$ = this.languageService.observeReload().subscribe(() => {
      this.reloadIframe();
    });


  }

  ngAfterViewInit() {
    this.iframe.nativeElement.addEventListener('load', this.onIframeLoad.bind(this));
  }

  reloadIframe() {

    let oldurl = '';
    this.loaderService.show();
    this.setIframeSrc('');
    if (this._urlAuthRedirectService.currentIframeUrl) {
      const protocol = `${this._urlAuthRedirectService.currentIframeUrl.includes('http') ? '' : `${environment.httpSchema}://`}`;
      oldurl = protocol + this._urlAuthRedirectService.currentIframeUrl;
    } else {
      if (this._path) {
        const protocol = `${this._path.includes('http') ? '' : `${environment.httpSchema}://`}`;
        oldurl = `` + protocol + this._path;
      }
    }
    this.setIframeSrc(oldurl);
  }

  onIframeLoad(e) {
    this.portalRenderService.end();
    this.loaderService.forceHide();
  }

  setIframeSrc(src) {

    this.src.set(src);

    this.portalRenderService.start();
    this.iframe.nativeElement.contentWindow.location.replace(src);
  }

  ngOnDestroy(): void {
    this.languageObservable$.unsubscribe();
  }


  openPdfInNewTab(url) {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = 'doc.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
  }
}
